import { capturePortalError } from "./sentry";

export function withTimeout(promise, timeoutMs, message = "Request timed out") {
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      const error = new Error(message);
      capturePortalError(error, {
        timeout: {
          message,
          timeoutMs,
          path: typeof window !== "undefined" ? window.location.pathname : "",
        },
      });
      reject(error);
    }, timeoutMs);
  });

  return Promise.race([promise, timeout]).finally(() => clearTimeout(timeoutId));
}

export function isTimeoutError(error) {
  return /timed out/i.test(error?.message || "");
}
